import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { Seal } from '../brand/Seal';
import { carePaths } from '../../data/carePaths';
import { articles } from '../../data/library';
import { useBrand } from '../../contexts/BrandContext';
export function Footer() {
  const {
    brand
  } = useBrand();
  return <footer className="border-t border-ink/10 bg-cream-deep text-ink" data-id="element-265" data-mp="5mkju2f1v1pl">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-266" data-mp="o9ea3vsfdd6">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-267" data-mp="3s2x8dodujj8t">
          <div data-id="element-268" data-mp="3s0khumu0w0k5">
            <Logo className="text-lg" markClassName="text-brick" data-id="element-269" data-mp="3n3k9u6dm4nqe" />
            <p className="mt-6 max-w-xs font-serif text-2xl leading-snug text-ink" data-id="element-270" data-mp="3n3u1dyeb32y7">
              {brand.copy.manifesto}
            </p>
            <Seal className="mt-10 h-24 w-24 text-brick/70" data-id="element-271" data-mp="3e2w3lxugnro2" />
          </div>

          <FooterColumn title="Care paths" data-id="element-272" data-mp="3e4yxwu2nc6yl">
            {carePaths.map(path => <FooterLink key={path.slug} to={`/care/${path.slug}`} data-id="element-273" data-mp="394kvbrjtdp7y">
                {path.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Answers" data-id="element-274" data-mp="2p4394adodanh">
            {articles.slice(0, 5).map(article => <FooterLink key={article.slug} to={`/library/${article.slug}`} data-id="element-275" data-mp="2bd7usikeq1ci">
                {article.question}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title={brand.name} data-id="element-276" data-mp="341dgb7jabude">
            <FooterLink to="/symptoms" data-id="element-277" data-mp="341lt6zfeqzol">Symptom decoder</FooterLink>
            <FooterLink to="/circles" data-id="element-278" data-mp="382yzfamex4w1">Circles</FooterLink>
            <FooterLink to="/treatments" data-id="element-279" data-mp="380cs9c3forec">Treatments</FooterLink>
            <FooterLink to="/testing" data-id="element-280" data-mp="2u24p2mft0tuq">Testing</FooterLink>
            <FooterLink to="/how-it-works" data-id="element-281" data-mp="2z1r2owzjoc42">How it works</FooterLink>
            <FooterLink to="/pricing" data-id="element-282" data-mp="2z43t7yjdbusq">Pricing</FooterLink>
            <FooterLink to="/about" data-id="element-283" data-mp="1imprbgfrtxyk">Who we are</FooterLink>
          </FooterColumn>
        </div>

        <div className="rule-light mt-16 pt-8" data-id="element-284" data-mp="1nnvmdkwwlxb9">
          <p className="max-w-4xl text-sm leading-relaxed text-ink-soft" data-id="element-285" data-mp="1nkhiu9ci7i28">
            {brand.name} is a direct-pay clinical practice specialising in perimenopause and
            menopause. Treatment is prescribed only where clinically appropriate following review by
            a licensed clinician. Compounded medications are not FDA-approved products and are
            dispensed by US-licensed 503A pharmacies. Everything published here is reviewed by a
            clinician and dated, and none of it is a substitute for individual medical advice.
          </p>
          <div className="mt-8 flex flex-col gap-4 text-sm text-ink-soft sm:flex-row sm:items-center sm:justify-between" data-id="element-286" data-mp="ftlmohic39cg">
            <p data-id="element-287" data-mp="bvnyni0autan">
              © {new Date().getFullYear()} {brand.copy.legalName}
            </p>
            <div className="flex gap-6" data-id="element-288" data-mp="6wjq8tl78zld">
              <Link to="/about" className="hover:text-brick" data-id="element-289" data-mp="2684bj1nlp5oh">
                Privacy
              </Link>
              <Link to="/about" className="hover:text-brick" data-id="element-290" data-mp="2188936ujxmb1">
                Terms
              </Link>
              <Link to="/about" className="hover:text-brick" data-id="element-291" data-mp="28qzc3amolqeg">
                HIPAA notice
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-292" data-mp="2nh6ksymvzv1y">
      <h2 className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-293" data-mp="2nfvgmxpj4lab">{title}</h2>
      <ul className="mt-6 flex flex-col gap-3" data-id="element-294" data-mp="1pty55k9khg7v">{children}</ul>
    </div>;
}
function FooterLink({
  to,
  children
}: {
  to: string;
  children: React.ReactNode;
}) {
  return <li data-id="element-295" data-mp="1zrc8qjae6air">
      <Link to={to} className="text-sm text-ink-soft transition-colors duration-150 ease-brand hover:text-brick" data-id="element-296" data-mp="1zrkl8a2lrdtf">
        {children}
      </Link>
    </li>;
}